export function LoadingSpinner({ size = "md" }: { size?: "sm" | "md" | "lg" }) {
  const s = { sm: "h-4 w-4 border-2", md: "h-8 w-8 border-2", lg: "h-12 w-12 border-3" };
  return (
    <div className="flex items-center justify-center p-8">
      <div className={`${s[size]} rounded-full border-[#b87800]/30 border-t-[#b87800] animate-spin`}
        style={{ boxShadow: "0 0 12px rgba(42, 74, 158, 0.3)" }} />
    </div>
  );
}
